import { IGeneralObjectType } from 'src/compass/site/util';
import { useExportOption } from 'src/compass/shared/util/useExportOption';
import CasPopoverMenu from '../../CasPopoverMenu/CasPopoverMenu';

type CasToolbarExportProps = {
  entity: string;
  params?: IGeneralObjectType;
};

export default function CasToolbarExport({ entity, params = {} }: CasToolbarExportProps) {
  const { exportOption } = useExportOption({ entity, params });

  return <CasPopoverMenu options={exportOption} />;
}
